import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AuthLayout from "./layouts/AuthLayout";
import AdminLayout from "./layouts/AdminLayout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";

import ProtectedRoute from "./routes/ProtectedRoute";
import UserProfile from "./pages/UserProfile";
import DepositList from "./pages/DepositList";
import WithdrawlList from "./pages/WithdrawlList";
import TradeList from "./pages/TradeList";
import LiveTrades from "./pages/LiveTrades";
import Salary from "./pages/Salary";
import Coupon from "./pages/Coupon";
import LeaderStats from "./pages/LeaderStats";
import TradeStatistics from "./pages/TradeStatistics";
import LiveTradesAll from "./pages/LiveTradesAll";
import TransactionStatistics from "./pages/TransactionStatistics";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* Protected admin routes */}
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/user-profile/:username" element={<UserProfile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/deposits" element={<DepositList />} />
          <Route path="/withdrawals" element={<WithdrawlList />} />
          <Route path="/trade-list" element={<TradeList />} />
          <Route path="/live-trades/:entity_id/:period" element={<LiveTrades />} />
          <Route path="/live-trades-all" element={<LiveTradesAll />} />
          <Route path="/salary" element={<Salary />} />
          <Route path="/coupon" element={<Coupon />} />
          <Route path="/leader-stats/:username" element={<LeaderStats />} />
          <Route path="/stats-trade" element={<TradeStatistics />} />
          <Route path="/stats-transaction" element={<TransactionStatistics />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
